import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MainComponent from "../../MainComponent";
import { useNavigate } from "react-router-dom";
import "./EcosystemMapping.css";
import EcMappingTasksidebar from "./EcMappingTasksidebar";
import {
  getEcosystemMappingSectionDetails,
  postEcosystemMappingSectionDetails,
} from "../../../store/actions";
import { url } from "../../../store/sagas/API.js";
import ChevronLeft from "../../../assets/images/Chevron-left.svg";
import Img from "../../../assets/images/f1.svg";
import ChevronRight from "../../../assets/images/Chevron-right.svg";
import { Button, Form } from "react-bootstrap";
import HelpInfo from "../../../utils/helpInfoProviderComponent.js";
import keys from "../../../utils/helpInfoKeys.json";
import CommentSection from "../../../utils/CommentSection.js";
import Login from "../../Login.js";
import SideNavHelpInfo from "../../../utils/SideNavHelpInfo.js";
import { motion } from "motion/react";
import EcMappingAddECSidebar from "./EcMappingAddECSidebar.js";
import Alert from "../../Alert.js";

function EcosystemMapping() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedHelpInfoSidebar = useSelector(
    (state) => state.selectedHelpInfoSidebar
  );
  const selectedBI = useSelector((state) => state.selectedBI);
  const [biName, setBIName] = useState(null);
  const [currentDocURL, setCurrentDocURL] = useState("");
  const [communityData, setCommunityData] = useState([]);
  const [SelectECMappingSidebar, setSelectECMappingSidebar] = useState(false);
  const [showEcosystemRHPO, setShowEcosystemRHPO] = useState(false);
  const [selectedSubSectionId, setSelectedSubSectionId] = useState("");
  const [sectionId, setSectionId] = useState("");
  const template_url = useSelector((state) => state.template_url);
  const isURLAdded = useSelector((state) => state.isURLAdded);
  const [editMode, setEditMode] = useState(null);
  const [edititemData, setEditItemData] = useState("");
  const [childrenId, setChildrenId] = useState("");
  const [seletedParentId, setSelectedParentId] = useState("");
  const [ChildrenData, setChildrenData] = useState([]);
  const [childName, setChildName] = useState("");
  const [subSectionName, setSubsectionName] = useState("");
  const selectedPermission = useSelector((state) => state.selectedPermission);
  const fetchEcosystemMappingSectionData = useSelector(
    (state) => state.fetchEcosystemMappingSectionData
  );
  const fetchPostEcosystemMappingSectionData = useSelector(
    (state) => state.fetchPostEcosystemMappingSectionData
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage, setCardsPerPage] = useState(4);

  const totalPages = Math.ceil(
    communityData.reduce(
      (total, sections) =>
        total + Math.ceil(sections.sub_section.length / cardsPerPage),
      0
    )
  );
  const startIndex = (currentPage - 1) * cardsPerPage;
  const endIndex = startIndex + cardsPerPage;
  const [pagination, setPagination] = useState({});
  const handlePageChange = (sectionId, newPage, totalPages) => {
    if (newPage < 1 || newPage > totalPages) return; // Prevent invalid page numbers
    setPagination((prev) => ({
      ...prev,
      [sectionId]: newPage,
    }));
  };
  useEffect(() => {
    if (selectedBI) {
      setBIName(selectedBI.label);
    }
  }, [selectedBI]);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1048) {
        setCardsPerPage(2); // For small screens and tablets
      } else {
        setCardsPerPage(4); // For desktop
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize(); // Initial setup based on screen width
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (fetchPostEcosystemMappingSectionData) {
      if (fetchPostEcosystemMappingSectionData.action === "add") {
        const newChild = {
          id: fetchPostEcosystemMappingSectionData.op_id,
          name: fetchPostEcosystemMappingSectionData.op_name,
          is_active: 1,
          is_master: 0,
        };

        const updatedSections = communityData.map((section) => {
          if (section.id === sectionId) {
            section.sub_section = section.sub_section.map((subsection) => {
              if (subsection.id === selectedSubSectionId) {
                subsection.childrens = subsection.childrens.map((child) => {
                  if (child.id === seletedParentId) {
                    // Add the new child to the parent child's childrens
                    child.childrens.push(newChild);
                  }
                  return child;
                });
              }
              return subsection;
            });
          }
          return section;
        });

        setCommunityData(updatedSections);
      } else if (fetchPostEcosystemMappingSectionData.action === "edit") {
        const updatedSections = communityData.map((section) => {
          if (section.id === sectionId) {
            section.sub_section = section.sub_section.map((subsection) => {
              if (subsection.id === selectedSubSectionId) {
                subsection.childrens = subsection.childrens.map((child) => {
                  if (child.id === seletedParentId) {
                    // Find and update the specific child
                    child.childrens = child.childrens.map((innerChild) => {
                      if (innerChild.id === childrenId) {
                        innerChild.name =
                          fetchPostEcosystemMappingSectionData.op_name;
                        innerChild.is_active = 1;
                        innerChild.is_master = 0;
                      }
                      return innerChild;
                    });
                  }
                  return child;
                });
              }
              return subsection;
            });
          }
          return section;
        });

        setCommunityData(updatedSections);
      }
    }
  }, [fetchPostEcosystemMappingSectionData]);
  useEffect(() => {
    if (
      fetchPostEcosystemMappingSectionData &&
      fetchPostEcosystemMappingSectionData?.action === "delete"
    ) {
      const updatedSections = [...communityData];
      const sectionIndex = updatedSections.findIndex((s) => s.id === sectionId);
      if (sectionIndex !== -1) {
        const subSectionIndex = updatedSections[
          sectionIndex
        ].sub_section.findIndex((sub) => sub.id === selectedSubSectionId);

        if (subSectionIndex !== -1) {
          const parentIndex = updatedSections[sectionIndex].sub_section[
            subSectionIndex
          ].childrens.findIndex((par) => par.id === seletedParentId);

          if (parentIndex !== -1) {
            const childrenArray =
              updatedSections[sectionIndex].sub_section[subSectionIndex]
                .childrens[parentIndex].childrens;

            updatedSections[sectionIndex].sub_section[
              subSectionIndex
            ].childrens[parentIndex].childrens = childrenArray.filter(
              (child) => child.id !== childrenId
            );
          }
        }
      }

      setCommunityData(updatedSections);
    }
  }, [fetchPostEcosystemMappingSectionData, childrenId]);

  useEffect(() => {
    if (
      fetchPostEcosystemMappingSectionData &&
      fetchPostEcosystemMappingSectionData.message === "ecosystemadded"
    ) {
      dispatch(
        getEcosystemMappingSectionDetails(localStorage.getItem("bi_id"))
      );
    } else if (
      fetchPostEcosystemMappingSectionData &&
      fetchPostEcosystemMappingSectionData.message ===
        "ecosystem already exists"
    ) {
      {
        Alert.warning({
          title: "Ecosystem Already exists",
          text: "This ecosystem has already been added. Please select a different one.",
          icon: "warning",
          showConfirmButton: true,
          preConfirm: (isConfirm) => {
            if (isConfirm) {
              window.location.reload();
            } else {
            }
          },
        });
      }
    }
  }, [fetchPostEcosystemMappingSectionData]);
  useEffect(() => {
    if (
      fetchEcosystemMappingSectionData &&
      fetchEcosystemMappingSectionData.sections.length > 0
    ) {
      setCommunityData(fetchEcosystemMappingSectionData.sections);
    }
  }, [fetchEcosystemMappingSectionData]);

  useEffect(() => {
    if (localStorage.getItem("bi_id")) {
      dispatch(
        getEcosystemMappingSectionDetails(localStorage.getItem("bi_id"))
      );
    }
  }, []);

  useEffect(() => {
    if (isURLAdded) {
      setCurrentDocURL(template_url);
    }
  }, [isURLAdded]);

  const handleBack = () => {
    navigate("/dashboard", { replace: true });
  };

  const handleClick = () => {
    navigate("/xlstrategymatrix", { replace: true });
  };
  const handleECMappingSidebar = (
    secId,
    childName,
    subsecId,
    subSecName,
    parentId,
    ChildrenData
  ) => {
    setChildrenData(ChildrenData);
    setSelectECMappingSidebar(true);
    setSelectedSubSectionId(subsecId);
    setChildName(childName);
    setSubsectionName(subSecName);
    setSectionId(secId);
    setSelectedParentId(parentId);
  };

  const handleTasksidebarClose = () => {
    setSelectECMappingSidebar(false);
    setShowEcosystemRHPO(false);
  };

  const handleEdit = (index, child, parentId) => {
    setChildrenId(child.id);
    setEditMode(index);
    setSelectedParentId(parentId);
    setEditItemData(child.name);
  };
  const handleDelete = (childrenId) => {
    setChildrenId(childrenId);
    dispatch(
      postEcosystemMappingSectionDetails(
        false,
        false,
        false,
        false,
        "delete",
        childrenId
      )
    );
  };
  const handleViewReport = () => {
    window.open("/reports", "_blank");
  };
  const content = (
    <>
      <motion.div
        initial={{ y: "100%" }}
        animate={{ y: 0 }}
        transition={{ duration: 0.8, ease: "easeInOut" }}
      >
        <div>
          <div style={{ display: "flex" }}>
            <div
              style={{
                fontSize: "var(--main-heading)",
                fontWeight: "var(--heading-font-weight)",
              }}
            >
              Ecosystem Mapping
            </div>
            <span style={{ margin: "5px" }}>
              <HelpInfo
                documentName={"Ecosystem Mapping"}
                helpKey={keys["Ecosystem Mapping"].EcosystemInfo}
              />
            </span>
          </div>
          <br />
          {communityData && communityData.length > 0 ? (
            communityData.map((sections, index) => {
              const currentPage = pagination[sections.id] || 1;
              const totalPages = Math.ceil(
                (sections.sub_section?.length || 0) / cardsPerPage
              );
              return (
                <div key={index}>
                  <div
                    style={{
                      fontSize: "var(--sub-heading-font-size)",
                      fontWeight: "var(--heading-font-weight)",
                    }}
                  >
                    {sections.name}
                  </div>
                  <div key={sections.id}>
                    <div
                      className="card-container"
                      style={{ display: "flex", marginTop: "5px" }}
                    >
                      {sections.sub_section &&
                        sections.sub_section.length > 0 &&
                        sections.sub_section
                          .slice(
                            (currentPage - 1) * cardsPerPage,
                            currentPage * cardsPerPage
                          )
                          .map((sub_section) => (
                            <div className="" key={sub_section.id}>
                              <div className="card-wrapper">
                                <div className="cards">
                                  <div className="card-body">
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      {sub_section.icon ? (
                                        <img
                                          alt="icon"
                                          src={url + sub_section.icon}
                                        />
                                      ) : (
                                        <img alt="icon" src={Img} />
                                      )}
                                      <div className="eco-mapping-card-title ">
                                        {sub_section.name}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {sub_section.childrens &&
                                sub_section.childrens.length > 0 &&
                                sub_section.childrens.map((child) => (
                                  <div
                                    key={child.id}
                                    className="ec-mapping-child-card"
                                  >
                                    <div
                                      className="sub_strategic_card"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                      onClick={() =>
                                        handleECMappingSidebar(
                                          sections.id,
                                          child.name,
                                          sub_section.id,
                                          sub_section.name,
                                          child.id,
                                          child
                                        )
                                      }
                                    >
                                      <div className="eco-mapping-card-sub-title ">
                                        {child.name}
                                      </div>
                                      <span>
                                        <img
                                          alt="chevronright"
                                          src={ChevronRight}
                                          width={20}
                                        />
                                      </span>
                                    </div>
                                  </div>
                                ))}
                            </div>
                          ))}
                    </div>
                  </div>

                  <div className="pagination">
                    <button
                      onClick={() =>
                        handlePageChange(
                          sections.id,
                          currentPage - 1,
                          totalPages
                        )
                      }
                      disabled={currentPage === 1}
                    >
                      <span style={{ opacity: currentPage === 1 ? 0.3 : 1 }}>
                        <img alt="chevronleft" src={ChevronLeft} width={25} />
                      </span>
                    </button>
                    <span style={{ margin: "0px 5px" }}>
                      {currentPage} / {totalPages}
                    </span>
                    <button
                      onClick={() =>
                        handlePageChange(
                          sections.id,
                          currentPage + 1,
                          totalPages
                        )
                      }
                      disabled={currentPage === totalPages}
                    >
                      <span
                        style={{
                          opacity: currentPage === totalPages ? 0.3 : 1,
                        }}
                      >
                        <img alt="chevronright" src={ChevronRight} width={25} />
                      </span>
                    </button>
                  </div>
                </div>
              );
            })
          ) : (
            <div style={{ fontSize: "var(--text-font-size)" }}>
              Please click on Add Ecosystem to add the ecosystem mapping.
            </div>
          )}
        </div>
        <div>
          <CommentSection />
          {selectedHelpInfoSidebar && <SideNavHelpInfo />}
        </div>
      </motion.div>

      {SelectECMappingSidebar && (
        <div>
          <EcMappingTasksidebar
            onClose={handleTasksidebarClose}
            setCommunityData={(value) => setCommunityData(value)}
            handleEdit={(index, childId, parentId) =>
              handleEdit(index, childId, parentId)
            }
            handleDelete={(childrenId) => handleDelete(childrenId)}
            editMode={editMode}
            setEditItemData={(value) => {
              setEditItemData(value);
            }}
            edititemData={edititemData}
            setEditMode={(value) => setEditMode(value)}
            seletedParentId={seletedParentId}
            ChildrenData={ChildrenData}
            childName={childName}
            subSectionName={subSectionName}
          />
        </div>
      )}
      {showEcosystemRHPO && (
        <div>
          <EcMappingAddECSidebar
            showEcosystemRHPO={showEcosystemRHPO}
            onClose={handleTasksidebarClose}
          />
        </div>
      )}
    </>
  );

  if (!localStorage.getItem("authenticated")) {
    return (
      <div>
        <Login />
      </div>
    );
  } else {
    return (
      <MainComponent
        maincontent={content}
        showSelector={true}
        showButtons={true}
        selectedPermission={selectedPermission}
        showViewReportButton={true}
        handleViewReport={handleViewReport}
        setShowEcosystemRHPO={setShowEcosystemRHPO}
        showAddEcosystemButton={true}
        handleNext={handleClick}
        handleBackButton={handleBack}
        breadcrumbParent={"Onboarding"}
        breadcrumbChild={"Ecosystem Mapping"}
        documentName={"Ecosystem Mapping"}
        helpKey={keys["Ecosystem Mapping"].Name}
        image={"question"}
      />
    );
  }
}

export default EcosystemMapping;

export const Reports = () => {
  const dispatch = useDispatch();
  const [communityData, setCommunityData] = useState([]);
  const fetchEcosystemMappingSectionData = useSelector(
    (state) => state.fetchEcosystemMappingSectionData
  );

  useEffect(() => {
    dispatch(getEcosystemMappingSectionDetails(localStorage.getItem("bi_id")));
  }, [dispatch]);

  useEffect(() => {
    if (
      fetchEcosystemMappingSectionData &&
      fetchEcosystemMappingSectionData.sections.length > 0
    ) {
      setCommunityData(fetchEcosystemMappingSectionData.sections);
    }
  }, [fetchEcosystemMappingSectionData]);

  return (
    <div className="ecosystem-reports-container">
      {communityData.map((section) => (
        <div key={section.id} className="ecosystem-reports-section">
          <h2 className="ecosystem-reports-section-title">{section.name}</h2>
          <table className="ecosystem-reports-table">
            <tbody>
              {section.sub_section.map((subSection) => (
                <React.Fragment key={subSection.id}>
                  <tr className="ecosystem-reports-sub-section-row">
                    <td className="ecosystem-reports-sub-section" colSpan={2}>
                      {subSection.name}
                    </td>
                  </tr>
                  {subSection.childrens.length > 0 ? (
                    subSection.childrens.map((child) => (
                      <tr
                        key={child.id}
                        className="ecosystem-reports-child-row"
                      >
                        <td className="ecosystem-reports-child">
                          {child.name}
                        </td>
                        <td
                          style={{ textAlign: "left" }}
                          className="ecosystem-reports-sub-children"
                        >
                          {child.childrens.length > 0 ? (
                            child.childrens.map((subChild) => (
                              <div
                                key={subChild.id}
                                className="ecosystem-reports-sub-child"
                              >
                                {subChild.name}
                              </div>
                            ))
                          ) : (
                            <span className="ecosystem-reports-no-sub-child">
                              No Data
                            </span>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={2} className="ecosystem-reports-no-children">
                        No Data
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
};
